import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PrintBulkVehicleService {

  constructor(private http:HttpClient) { }
  private token='';


  getcampusdetail() {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.printasseturl + '/apiV2/common/empCampuses', { headers });
  }

  getbuildingdetail(campusid: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.printasseturl + '/apiV2/common/empCmpBuilding?campusId=' + campusid, { headers });
  }

  gettabledetail(buildingid: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.orgUrl + '/apiV2/vehicleAssetTracking/approvedVehicleList?buildingId=' + buildingid, { headers });;
  }

  getgeneratepdf(buildingid: any): Observable<Blob> {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.orgUrl + '/apiV2/assetTracking/generateBulkQrCodePdf?buildingId=' + buildingid, { headers, responseType: 'blob', });
  }
}
